import * as types from './type';
import { createReducer } from '@reduxjs/toolkit';

const reducerSchema = (types, initialState = {}) => {
  return createReducer(initialState, {
    [types.ACTION_RESET]: (state, action) => {
      const key = action.payload.key ? action.payload.key : 'default';
      if (state[key]) {
        state[key] = { ...initialState };
      }
      return state;
    },
    [types.ACTION_ERROR]: (state, action) => {
      const key = action.payload.key ? action.payload.key : 'default';
      const originalState = state[key] || {};
      const newState = {
        ...originalState,
        isLoading: false,
        data: action.payload.data,
        error: true,
      };
      state[key] = newState;
      return state;
    },
    [types.ACTION_SUCCESS]: (state, action) => {
      const key = action.payload.key ? action.payload.key : 'default';
      const originalState = state[key] || {};
      const newState = {
        ...originalState,
        isLoading: false,
        data: action.payload.data,
        error: false,
      };
      state[key] = newState;
      return state;
    },
    [types.ACTION_REQUEST]: (state, action) => {
      const key = action.payload.key ? action.payload.key : 'default';
      const originalState = state[key] || {};
      const newState = {
        ...originalState,
        isLoading: true,
        ...(action.payload && { params: action.payload }),
        error: false,
      };
      state[key] = newState;
      return state;
    },
  });
};

const reducer = reducerSchema(types);

export default reducer;
